document.addEventListener('DOMContentLoaded', function () {
  
  var check_if_atc = localStorage.getItem('add_to_cart');
  if (check_if_atc == 1) {
    var cart_bubble = document.getElementById('cart-icon-bubble'); // Corrected method name
    if (cart_bubble) {
      setTimeout(function(){
        cart_bubble.click(); // Trigger the click event
        localStorage.removeItem('add_to_cart');
      }, 500);      
    }
  }
  
  // Get all the variant radio buttons
  const variantRadios = document.querySelectorAll('main#MainContent .product__info-wrapper variant-selects input[type="radio"]');
  
  // Get the slider images
  const sliderImages = document.querySelectorAll('.product__media-item img');

  // Get the media gallery elements
  const mediaGallery = document.querySelector('media-gallery');
  
  variantRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      // Get the image source of the selected variant
      const selectedImgSrc = this.nextElementSibling.getAttribute('data-img-src');
      const selected_val = this.getAttribute('value');
      const selected_attr = this.getAttribute('name');

      const productInfogrid = this.closest('.product__info-wrapper');

      const closestInput = this.closest('.product-form__input');
      const labels = closestInput.querySelectorAll('.product-form__label-container .form__label span');
      labels.forEach(label => {
        label.innerHTML = selected_attr + ' - ' + selected_val;
      });

      const variantSelect = this.closest('variant-selects');
      variantSelect.setAttribute('data-options', selected_val);

      // Assuming `productInfogrid` is already defined as an element
      const variant_selector_grid = productInfogrid.querySelectorAll('.product-variant-selector-grid');
      
      // Find the first product variant selector
      const variant_selector = variant_selector_grid[0].querySelector('.product-variant-selector');
      
      // Loop through all options in the variant selector
      const options = variant_selector.querySelectorAll('option');
      options.forEach(function(option) {
        // Check if the option text matches the selected value
        if (option.textContent === selected_val) {
          const variantID = option.value;
      
          // Find the .product-form and set the value for .product-variant-id
          const productForm = productInfogrid.querySelector('.product-form');
          const variantIdElement = productForm.querySelector('.product-variant-id');
          if (variantIdElement) {
            variantIdElement.setAttribute('value', variantID);
          }
        }
      });


      // Loop through slider images and find the matching one
      sliderImages.forEach(slideImg => {
        // Check if the slider image source contains the selected image source (partial match)
        if (slideImg.getAttribute('src').includes(selectedImgSrc)) {
          // Get the mediaId (assuming you have this data attribute in the HTML)
          const mediaId = slideImg.closest('.slider__slide').dataset.mediaId;

          // Call the setActiveMedia function to update the active slide and handle scrolling
          if (mediaGallery && mediaId) {
            mediaGallery.setActiveMedia(mediaId, false, false);  // You can adjust the parameters as needed
          }
        }
      });
    });
  });


  // Add a single event listener to a parent container for delegation
  document.body.addEventListener('click', async function (e) {
    // Check if the clicked element is a button within the main product form
    const button = e.target.closest('.main-product-form .product-form__submit');
    if (!button) {
      return; // Exit if the clicked element is not the target button
    }
  
    e.preventDefault();
    const wrapper = button.closest('.product__info-wrapper');
    wrapper.classList.add('fadeop');
    try {
      // Locate the form
      const form = button.closest('form[data-type="add-to-cart-form"]');
      if (!form) {
        throw new Error("Form with 'data-type=add-to-cart-form' not found.");
      }
  
      // Retrieve variant ID and quantity
      const variantInput = form.querySelector('input.product-variant-id');
      const quantityInput = form
        .closest('.product__info-container')
        .querySelector('.product-form__quantity input[name="quantity"]');
  
      if (!variantInput || !quantityInput) {
        throw new Error("Required inputs (variant ID or quantity) are missing.");
      }
  
      const variantID = variantInput.value.trim();
      const quantity = parseInt(quantityInput.value, 10);
  
      if (!variantID || isNaN(quantity) || quantity <= 0) {
        throw new Error("Invalid variant ID or quantity.");
      }
  
      console.log("Adding to cart:", { variantID, quantity });
  
      // Add item to the cart
      const addToCartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantID, quantity }),
      });
  
      if (!addToCartResponse.ok) {
        throw new Error("Failed to add item to cart.");
      }
  
      console.log("Item added to cart.");
  
      // Fetch the updated cart
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error("Failed to fetch cart.");
      }
  
      const cartData = await cartResponse.json();
      console.log("Updated cart data:", cartData);
  
      // Update UI or reload
      localStorage.setItem("add_to_cart", "1");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("Error handling button click:", error);
    }
  });


  // Select all sticky add-to-cart buttons
  const stickyAtcButtons = document.querySelectorAll('.sticky-atc .main-product-atc');  
  stickyAtcButtons.forEach(button => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();

      
      // Find the form element closest to the parent container
      const form = this.closest('#MainContent').querySelector('form[data-type="add-to-cart-form"]');
      const variantID = form.querySelector('input.product-variant-id').value;
      const quantity = parseInt(
        form.closest('.product__info-container')
             .querySelector('.product-form__quantity input[name="quantity"]').value,
        10
      );
  
      if (variantID) {
        try {
          // Add the item to the cart
          const addToCartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantID, quantity })
          });
  
          if (!addToCartResponse.ok) {
            throw new Error('Error adding to cart');
          }
  
          // Fetch the updated cart
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
  
          // Log the updated cart data (optional debugging step)
          console.log(cartData);
  
          // Trigger UI changes
          localStorage.setItem("add_to_cart", "1");
          setTimeout(() => {
            window.location.reload();
          }, 800);
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      } else {
        console.error('Variant ID or quantity is missing');
      }
    });
  });



  document.body.addEventListener('click', async function (e) {
    // Check if the clicked element is a button within the main product form
    const button = e.target.closest('.product-grid .grid__item .quick-add__submit');
    if (!button) {
      return; // Exit if the clicked element is not the target button
    }
    e.preventDefault();
  
    try {
      // Locate the form
      const form = button.closest('form[data-type="add-to-cart-form"]');
      if (!form) {
        throw new Error("Form with 'data-type=add-to-cart-form' not found.");
      }
  
      // Retrieve variant ID and quantity
      const variantInput = form.querySelector('input[name="id"]');

      if (!variantInput) {
        throw new Error("Required inputs (variant ID or quantity) are missing.");
      }
  
      const variantID = variantInput.value.trim();
      const quantity = 1;

      if (!variantID || isNaN(quantity) || quantity <= 0) {
        throw new Error("Invalid variant ID or quantity.");
      }
  
      console.log("Adding to cart:", { variantID, quantity });
  
      // Add item to the cart
      const addToCartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantID, quantity }),
      });
  
      if (!addToCartResponse.ok) {
        throw new Error("Failed to add item to cart.");
      }
  
      console.log("Item added to cart.");
  
      // Fetch the updated cart
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error("Failed to fetch cart.");
      }
  
      const cartData = await cartResponse.json();
      console.log("Updated cart data:", cartData);
  
      // Update UI or reload
      localStorage.setItem("add_to_cart", "1");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("Error handling button click:", error);
    }
  });
  

});






